import React from 'react';

export const NotRunningIcon = (): React.ReactElement => (
  <svg width="24.000000" height="24.000000" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="clip1123_4736">
        <rect id="file-diff" width="24.000000" height="24.000000" fill="white" fillOpacity="0" />
      </clipPath>
    </defs>
    <rect id="file-diff" width="24.000000" height="24.000000" fill="#FFFFFF" fillOpacity="0" />
    <g clipPath="url(#clip1123_4736)">
      <path
        id="Vector"
        d="M6 0L18 0C18.79 0 19.55 0.31 20.12 0.87C20.68 1.44 21 2.2 21 3L21 21C21 21.79 20.68 22.55 20.12 23.12C19.55 23.68 18.79 24 18 24L6 24C5.2 24 4.44 23.68 3.87 23.12C3.31 22.55 3 21.79 3 21L3 3C3 2.2 3.31 1.44 3.87 0.87C4.44 0.31 5.2 0 6 0L6 0ZM6 1.5C5.6 1.5 5.22 1.65 4.93 1.93C4.65 2.22 4.5 2.6 4.5 3L4.5 21C4.5 21.39 4.65 21.77 4.93 22.06C5.22 22.34 5.6 22.5 6 22.5L18 22.5C18.39 22.5 18.77 22.34 19.06 22.06C19.34 21.77 19.5 21.39 19.5 21L19.5 3C19.5 2.6 19.34 2.22 19.06 1.93C18.77 1.65 18.39 1.5 18 1.5L6 1.5Z"
        fill="#3D5A80"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
      <path
        id="Vector"
        d="M8.25 15.75C8.25 15.55 8.32 15.36 8.46 15.21C8.61 15.07 8.8 15 9 15L15 15C15.19 15 15.38 15.07 15.53 15.21C15.67 15.36 15.75 15.55 15.75 15.75C15.75 15.94 15.67 16.13 15.53 16.28C15.38 16.42 15.19 16.5 15 16.5L9 16.5C8.8 16.5 8.61 16.42 8.46 16.28C8.32 16.13 8.25 15.94 8.25 15.75ZM12 6C12.19 6 12.38 6.07 12.53 6.21C12.67 6.36 12.75 6.55 12.75 6.75L12.75 9L15 9C15.19 9 15.38 9.07 15.53 9.21C15.67 9.36 15.75 9.55 15.75 9.75C15.75 9.94 15.67 10.13 15.53 10.28C15.38 10.42 15.19 10.5 15 10.5L12.75 10.5L12.75 12.75C12.75 12.94 12.67 13.13 12.53 13.28C12.38 13.42 12.19 13.5 12 13.5C11.8 13.5 11.61 13.42 11.46 13.28C11.32 13.13 11.25 12.94 11.25 12.75L11.25 10.5L9 10.5C8.8 10.5 8.61 10.42 8.46 10.28C8.32 10.13 8.25 9.94 8.25 9.75C8.25 9.55 8.32 9.36 8.46 9.21C8.61 9.07 8.8 9 9 9L11.25 9L11.25 6.75C11.25 6.55 11.32 6.36 11.46 6.21C11.61 6.07 11.8 6 12 6Z"
        fill="#3D5A80"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
